/* MT – scripts propios de la tienda (sin librerías) */
(function () {
  function initReveal() {
    var els = document.querySelectorAll('.mt-reveal');
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('mt-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('mt-visible');
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0, rootMargin: '0px 0px -6% 0px' });
    els.forEach(function (el) { io.observe(el); });
    // Respaldo: si el observador no llega a dispararse, muestra lo que ya está en pantalla
    setTimeout(function () {
      els.forEach(function (el) {
        var r = el.getBoundingClientRect();
        if (r.top < window.innerHeight && r.bottom > 0) el.classList.add('mt-visible');
      });
    }, 1800);
  }

  function initGaleria() {
    document.querySelectorAll('[data-mt-galeria]').forEach(function (gal) {
      var principal = gal.querySelector('[data-mt-principal]');
      if (!principal) return;
      gal.querySelectorAll('[data-mt-mini]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          principal.src = btn.getAttribute('data-src');
          principal.removeAttribute('srcset');
          principal.alt = btn.getAttribute('data-alt') || '';
          gal.querySelectorAll('[data-mt-mini]').forEach(function (b) { b.classList.remove('mt-activa'); });
          btn.classList.add('mt-activa');
        });
      });
    });
  }

  function initCantidad() {
    document.querySelectorAll('[data-mt-cant]').forEach(function (caja) {
      var input = caja.querySelector('input');
      var destino = document.querySelector(caja.getAttribute('data-mt-cant'));
      function set(v) {
        v = Math.max(1, parseInt(v, 10) || 1);
        input.value = v;
        if (destino) destino.value = v;
      }
      caja.querySelectorAll('button').forEach(function (b) {
        b.addEventListener('click', function () { set(parseInt(input.value, 10) + parseInt(b.getAttribute('data-paso'), 10)); });
      });
      input.addEventListener('change', function () { set(input.value); });
    });
  }

  function initVariantes() {
    document.querySelectorAll('[data-mt-producto]').forEach(function (raiz) {
      var datos = raiz.querySelector('[data-mt-variantes]');
      if (!datos) return;
      var variantes;
      try { variantes = JSON.parse(datos.textContent); } catch (e) { return; }
      var idInput = raiz.querySelector('input[name="id"]');
      var boton = raiz.querySelector('[data-mt-comprar]');
      var precio = raiz.querySelector('[data-mt-precio]');
      var tachado = raiz.querySelector('[data-mt-tachado]');
      var txtComprar = boton ? boton.getAttribute('data-txt') : '';
      var txtAgotado = boton ? boton.getAttribute('data-agotado') : '';
      var grupos = raiz.querySelectorAll('[data-mt-opcion]');
      if (!grupos.length) return;

      function actualizar() {
        var elegidas = [];
        grupos.forEach(function (g) {
          var c = g.querySelector('input:checked');
          elegidas.push(c ? c.value : null);
        });
        var v = variantes.filter(function (x) {
          return x.options.every(function (o, i) { return o === elegidas[i]; });
        })[0];
        if (!v) {
          if (boton) { boton.disabled = true; boton.querySelector('span').textContent = txtAgotado; }
          return;
        }
        if (idInput) idInput.value = v.id;
        if (precio) precio.textContent = v.price_fmt;
        if (tachado) {
          tachado.textContent = v.compare_fmt || '';
          tachado.style.display = v.compare_fmt ? '' : 'none';
        }
        if (boton) {
          boton.disabled = !v.available;
          boton.querySelector('span').textContent = v.available ? txtComprar : txtAgotado;
        }
        if (v.image) {
          var p = raiz.querySelector('[data-mt-principal]');
          if (p) { p.src = v.image; p.removeAttribute('srcset'); }
        }
      }
      grupos.forEach(function (g) { g.addEventListener('change', actualizar); });
    });
  }

  function init() {
    initReveal();
    initGaleria();
    initCantidad();
    initVariantes();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
